module.exports = __webpack_public_path__ + "img/f285288.svg";